<template>
  <ul class="ml-2 grow list-inside list-disc text-base text-type-secondary">
    <li v-if="reportedAtFormatted">{{ t('3iysSlUuhzqBRe3yuLpIS', [reportedAtFormatted]) }}</li>
    <li>
      <i18n-t keypath="SgFZC8ud_hQUv2C6aoq0Z" :i18n="composer">
        <template #last-updated>
          <ui-relative-time :time="selectedIncident?.updatedAt" />
        </template>
      </i18n-t>
    </li>
    <li>{{ t('3eIWm6APTaigbHWnqrGOa', [selectedIncident?.incidentStatus]) }}</li>
    <li v-if="selectedIncident?.reportedNear">{{ t('Cz27JOfAIWMT9XIcilsiZ', [selectedIncident?.reportedNear]) }}</li>
    <li v-else-if="selectedIncident?.reportedIn">{{ t('zWZglq5qu2ZJzYHeo6C5r', [selectedIncident?.reportedIn]) }}</li>
  </ul>
</template>

<script setup lang="ts">
import { useHazardsStore, useMapStore } from '@/features/hazards';
import { formatReportedAt } from '@/features/hazards/presentation/helpers/format-reported-at-datetime';
import { i18n } from '@/locales';
import { computed } from 'vue';
import { Composer, I18nT } from 'vue-i18n';

const map = useMapStore();
const hazards = useHazardsStore();

const selectedIncident = computed(() => {
  return hazards?.hazards?.incidents.find((incident) =>
    [hazards.selectedHazard?.hazardId, map.selectedPopupHazard?.hazardId].includes(incident.id)
  );
});

const composer = i18n.global as Composer;
const { locale, t } = i18n.global;

const reportedAtFormatted = computed(() => {
  // Track locale changes
  void locale.value;

  if (!selectedIncident?.value?.reportedAt) {
    return '';
  }

  return formatReportedAt(selectedIncident?.value?.reportedAt);
});
</script>
